<template>
  <div v-if="move_position_order && move_position_order.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('PositionMoves', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/move-position-order/' + move_position_order.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{
          $t("CRUD.viewInfo", [$t("MovePositionOrder.ObjectName")])
        }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showEdit &&
          move_position_order.actions &&
          move_position_order.actions.edit &&
          $permission.permissionAllow('PositionMoves', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push(
                      '/move-position-order/' + move_position_order.id + '/edit'
                    );
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("MovePositionOrder.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("MovePositionOrder.actions.editMovePositionOrder") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showShelveOn &&
          move_position_order.actions &&
          move_position_order.actions.shelve_on &&
          $permission.permissionAllow('PositionMoves', 'shelveOn')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('shelveOn')
                  : $router.push(
                      '/move-position-order/' +
                        move_position_order.id +
                        '/shelveOn'
                    );
              })
            "
          >
            {{ $t("MovePositionOrder.actions.shelveOn") }}
          </v-btn>
        </template>
        <span>{{ $t("MovePositionOrder.actions.shelveOn") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showShelveOff &&
          move_position_order.actions &&
          move_position_order.actions.shelve_off &&
          $permission.permissionAllow('PositionMoves', 'shelveOff')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('shelveOff')
                  : $router.push(
                      '/move-position-order/' +
                        move_position_order.id +
                        '/shelveOff'
                    );
              })
            "
          >
            {{ $t("MovePositionOrder.actions.shelveOff") }}
          </v-btn>
        </template>
        <span>{{ $t("MovePositionOrder.actions.shelveOff") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel &&
          move_position_order.actions &&
          move_position_order.actions.cancel &&
          $permission.permissionAllow('PositionMoves', 'cancel')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("MovePositionOrder.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{
          $t("MovePositionOrder.actions.cancelMovePositionOrder")
        }}</span>
      </v-tooltip>
    </v-sheet>

    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('MovePositionOrder.ObjectName')"
      :code="move_position_order.move_order_code"
      @confirm="doAction('cancel')"
    />
  </div>
</template>

<script>
import MovePositionOrders from "@/api/move_position_orders";
import DialogDelete from "@/components/plugins/DialogDelete";
export default {
  name: "MovePositionOrderActions",

  components: {
    DialogDelete,
  },

  props: {
    move_position_order: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showShelveOn: Boolean,
    showCancel: Boolean,
    showShelveOff: Boolean,
    shelveOffMode: Boolean,
    shelveOnMode: Boolean,
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    cancelAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel")
        return MovePositionOrders.cancel(this.move_position_order.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (this.detailMode) this.$router.push("/move-position-order");

                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
  },
};
</script>